/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */


/*@ngInject*/
export default function CustomerSubscriptionTableConfig($translate, $mdDialog, $document, $state, toast, types, utils, userService, customerSubscriptionService) {

    var service = {
        getConfig: getConfig
    }

    return service;

    function getConfig(/*params*/) {
        var currentUser = userService.getCurrentUser();
        var authority = currentUser.authority;
        var scope = types.authority[authority].scope;
        var access = types.authority[authority].access;
        var tableConfiguration = {

            scope: scope,

            entityType: types.entityType.customer_subscription,

            tableTitle: $translate.instant('customerSubscription.customerSubscriptions'),

            columns: [
                { key: 'createdTime',
                  title: 'entity.createdTime'},
                { key: 'name',
                  title: 'subscription.name'},
                { key: 'additionalInfo.price',
                    title: 'subscription.price',
                    cellContentFunction:
                        (value, entity, $filter) => entity && entity.additionalInfo ? $filter('currency')(entity.additionalInfo.price, '$') : ''
                }
            ],

            loadEntities: () => {return customerSubscriptionService.getCustomerSubscriptions()},
            loadEntity: (entityId) => {return customerSubscriptionService.getCustomerSubscription(entityId)},
            saveEntity: (entity) => {return customerSubscriptionService.saveCustomerSubscription(entity)},
            deleteEntity: (entityId) => {return customerSubscriptionService.deleteCustomerSubscription(entityId)},

            detailsReadOnly: () => {
                return access == types.access.user;
            },

            addEnabled: () => {
                return access == types.access.admin;
            },

            deleteEnabled: () => {
                return access == types.access.admin;
            },
            entitiesDeleteEnabled: () => {
                return access == types.access.admin;
            },
            deleteEntityTitle: (entity) => {
                return $translate.instant('subscription.delete-subscription-title', {name: entity.name});
            },
            deleteEntityContent: (/*entity*/) => {
                return $translate.instant('subscription.delete-subscription-text');
            },
            deleteEntitiesTitle: (count) => {
                return $translate.instant('subscription.delete-subscriptions-title', {count: count}, 'messageformat');
            },
            deleteEntitiesContent: (/*count*/) => {
                return $translate.instant('subscription.delete-subscriptions-text');
            }

        };

        utils.tableConfigDefaults(tableConfiguration);

        return tableConfiguration;
    }

}



// WEBPACK FOOTER //
// ./src/app/customer/subscription/customer-subscription-table.config.js